import React from 'react';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { useSelector } from 'react-redux';
const ErrorForm = () => {
  const error = useSelector(state => state.errorReducer.error);
  return (
    <div className="container page">
      <div className="col-md-6 offset-md-3 col-xs-12">
        <Card boxShadow={3}>
          <CardContent>
            <div className="headerAlign text-xs-center">
              <Typography
                className="title-h5"
                gutterBottom
                variant="h5"
                color="primary"
              >
                Internal Server Error
              </Typography>
              <Typography
                display="block"
                gutterBottom
                variant="h6"
                className="text-xs-center"
                paragraph={true}
              >
                An error occurred while processing your request. If the problem
                persists, please contact Customer Service at 1-800-226-3545.
              </Typography>
              {error && (
                <div className="headerAlign">
                  <Typography
                    className="h6"
                    gutterBottom
                    variant="h6"
                    color="error"
                  >
                    {error}
                  </Typography>
                </div>
              )}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
export default ErrorForm;
